function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import ScrollMagic from 'scrollmagic';
import { gsap, Power4 } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
export var mediahawkBehavior = function mediahawkBehavior() {
  Alpine.data('mediahawkBehavior', function () {
    return {
      dispatcher: null,
      scrollTrigger: false,
      controller: false,
      scenes: [],
      sections: [],
      stickyScene: false,
      mediahawkOffset: {
        top: 0,
        bottom: 0,
        height: 0
      },
      adminToolbarHeight: 0,
      triggerOffset: 220,
      scrollSpeed: 0.75,
      init: function init() {
        if (breakpoint.isDesktop) {
          this.desktopInit();
        }

        if (breakpoint.isTouch) {
          this.mobileInit();
        }
      },
      desktopInit: function desktopInit() {
        var $element = this.$el;
        this.mediahawkOffset = this.getMediahawkDimensions($element);
        this.scenes = [];
        this.controllerInit();
        this.stickMediahawkElement();
      },
      mobileInit: function mobileInit() {
        this.controllerInit();
        this.shrinkMediahawk();
      },
      controllerInit: function controllerInit() {
        var _this = this;

        if (this.controller) {
          this.controller.destroy();
        }

        this.calculateOffset();
        this.controller = new ScrollMagic.Controller();
        this.controller.scrollTo(function (newPosition) {
          var $this = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this;
          gsap.to(window, {
            duration: $this.scrollSpeed,
            ease: Power4.easeInOut,
            scrollTo: {
              y: newPosition,
              offsetY: $this.triggerOffset + $this.mediahawkOffset.outerHeight
            }
          });
        });
      },
      stickMediahawkElement: function stickMediahawkElement() {
        if (this.scrollTrigger) {
          this.scrollTrigger.kill(true);
        }

        var $this = this;
        var $mediaContainer = this.$el;
        $mediaContainer.classList.remove('m-mediahawk__shrink');
        this.scrollTrigger = ScrollTrigger.create({
          trigger: $mediaContainer,
          endTrigger: '.tlc__content',
          pin: true,
          pinSpacing: false,
          start: "top top+=".concat($this.triggerOffset),
          end: "bottom top+=".concat($this.triggerOffset + $this.mediahawkOffset.height + 150),
          markers: false // Useful for debugging.

        });
      },
      getMediahawkDimensions: function getMediahawkDimensions(element) {
        // Get the DOM Node if you pass in a string
        var $element = typeof element === 'string' ? document.querySelector(element) : element;

        var _$element$getBounding = $element.getBoundingClientRect(),
            top = _$element$getBounding.top,
            right = _$element$getBounding.right,
            bottom = _$element$getBounding.bottom,
            left = _$element$getBounding.left,
            width = _$element$getBounding.width,
            height = _$element$getBounding.height,
            x = _$element$getBounding.x,
            y = _$element$getBounding.y;

        var dimensions = {
          top: top,
          right: right,
          bottom: bottom,
          left: left,
          width: width,
          height: height,
          x: x,
          y: y
        };
        var styles = window.getComputedStyle($element);
        var marginTop = parseFloat(styles.marginTop);
        var marginBottom = parseFloat(styles.marginBottom);
        var marginY = marginTop + marginBottom;
        var outerHeight = Math.ceil(height + marginY);
        return _objectSpread(_objectSpread({}, dimensions), {}, {
          outerHeight: outerHeight,
          marginTop: marginTop,
          marginBottom: marginBottom,
          marginY: marginY
        });
      },
      calculateOffset: function calculateOffset() {
        this.triggerOffset = 150;
        var adminToolbar = document.querySelector('#toolbar-bar');

        if (adminToolbar) {
          var adminToolbarDimensions = this.getMediahawkDimensions(adminToolbar);
          this.adminToolbarHeight = adminToolbarDimensions.outerHeight;
          this.triggerOffset += this.adminToolbarHeight;
        }
      },
      shrinkMediahawk: function shrinkMediahawk() {
        if (this.scrollTrigger) {
          this.scrollTrigger.kill(true);
        }

        var $mediaContainer = this.$el;
        this.scrollTrigger = ScrollTrigger.create({
          trigger: $mediaContainer,
          endTrigger: '.tlc__content',
          start: "top top+=120",
          end: "bottom top+=480",
          onEnter: function onEnter() {
            return $mediaContainer.classList.add('m-mediahawk__shrink');
          },
          onLeaveBack: function onLeaveBack() {
            return $mediaContainer.classList.remove('m-mediahawk__shrink');
          },
          pin: true,
          pinSpacing: false,
          markers: false // Useful for debugging.

        });
      },
      mediahawk: {
        // eslint-disable-next-line func-names
        '@resize.window.stop.debounce.200ms': function resizeWindowStopDebounce200ms() {
          if (breakpoint.isDesktop) {
            this.desktopInit();
          } else {
            this.mobileInit();
          }
        },
        // eslint-disable-next-line func-names
        '@load.window': function loadWindow() {
          this.init();
        }
      }
    };
  });
};